const styles = {
  orangeButton: {
    backgroundColor: "#EE4622",
    borderColor: "#EE4622",
    borderRadius: "5px",
  },
  grayButton: {
    backgroundColor: "gray",
    borderColor: "gray",
    borderRadius: "5px",
  },
};

export default styles;
